import * as types from './mutation-types'

export const loadDgiTaxes = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/dgi-taxes/collection').then((response) => {
            commit(types.ADD_DGI_TAXES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
